module.exports = __webpack_public_path__ + "static/9-f07fdcd2cf7e525ce4305503de41e563.jpeg";